import React from "react";
import moment from "moment";
import { ButtonDS } from "get-life-storybook-ts";
import numberFormat from "../../../utils/Utils";
import { ProgressionListI } from "../DecisionPage.controller";
import WelcomeSQL from "../../DecisionPageSQL/components/Welcome/WelcomeSQL.component";
import ProgressionSQL from "../../DecisionPageSQL/components/Progression.component";
import { CapitalsResponse } from "../../../api/request/Lead/Interfaces/DataInterface.response";
import { TraitName } from "../../../api/request/Lead/Interfaces/TraitTypes";

interface DecisionPageSQLLayoutProps {
  data: any;
  progression: ProgressionListI[];
  translate: (key: string) => string;
  continueProcess: () => void;
  brokerPhone?: string;
}

const DecisionPageSQLLayout: React.FC<DecisionPageSQLLayoutProps> = ({
  data,
  progression,
  translate,
  continueProcess,
  brokerPhone,
}) => {
  const phoneNumber = brokerPhone || process.env.REACT_APP_TEL;

  const capitals: CapitalsResponse | undefined = data?.capitals;
  const activeTraits: TraitName[] = capitals
    ? (Object.keys(capitals) as TraitName[]).filter(
        (key) => capitals[key]?.active
      )
    : [];
  const extraTraits = activeTraits.filter((trait) => trait !== "DEATH");
  const deathCapital = capitals?.DEATH?.capital ?? 0;

  return (
    <>
      <div className="w-full flex flex-col max-w-[740px]">
        <div className="w-full flex justify-center pt-[60px] pb-[40px]">
          <WelcomeSQL />
        </div>
        <div className="w-full flex flex-col gap-6 items-center pb-10 justify-between md:flex-row md:items-start md:gap-0">
          <div
            className="w-[327px] rounded-[8px]"
            style={{
              boxShadow:
                "0px -1px 0px 0px rgba(66, 66, 66, 0.10) inset, 0px 1px 3px 0px rgba(66, 66, 66, 0.10)",
            }}
          >
            <div className="flex items-center w-full bg-[var(--theme-tertiary)] px-5 py-[8px] border border-[#A09FFA] rounded-t-[8px]">
              <span className="BodyS font-bold text-purple">
                {translate("welcome.sql.guarantee.title")}
              </span>
            </div>
            <div className="flex flex-col w-full px-5 pt-6 pb-4 border borde-[1px] border-[#A09FFA] break-words border-t-0">
              <span className="BodyS text-[#686868]">
                {translate("welcome.sql.people")}
              </span>
              <span className="BodyXL font-bold text-purple">
                {data?.email}
              </span>
              <span className="BodyS text-[#7B7B7B]">
                {data?.birthDate &&
                  moment(data?.birthDate).format("DD/MM/YYYY")}
              </span>
            </div>
            <div className="flex flex-col w-full px-5 pt-6 pb-4 border border-[#A09FFA] break-words border-t-0">
              <span className="BodyS text-[#686868]">
                {translate("welcome.sql.totalCapital")}
              </span>
              <span className="BodyXL font-bold text-purple">
                {deathCapital > 0 && numberFormat(deathCapital, "capital")}
              </span>
              {data?.intention && data.intention.length != -1 && (
                <span className="BodyS text-[#7B7B7B]">
                  {translate(`welcome.sql.intention.${data.intention[0]}`)}
                </span>
              )}
            </div>
            <div className="flex flex-col w-full px-5 pt-5 pb-4 border border-[#A09FFA] break-words border-t-0 rounded-b-[8px]">
              <span className="BodyS text-[#686868]">
                {translate("welcome.sql.coverage")}
              </span>
              <span className="BodyXL font-bold text-purple">
                {translate("welcome.guarantee.death")}
              </span>
              {extraTraits.map((key) => (
                <span key={key} className="BodyS text-[#7B7B7B]">
                  +{" "}
                  {translate(`welcome.multiproduct.${key.toLowerCase()}`)}
                  {`: ${numberFormat(capitals?.[key]?.capital ?? 0, "capital")}`}
                </span>
              ))}
            </div>
          </div>
          <div className="opacity-0 w-[1px] self-stretch bg-[var(--theme-primary)] md:opacity-100"></div>
          <div className="flex flex-col gap-[40px]">
            <ProgressionSQL
              title={translate("welcome.Progression.title")}
              list={progression}
              type=""
            />
            <div className="flex flex-col px-6 gap-4">
              <span className="BodyM text-[#424242]">
                {translate("welcome.continue.question")}
              </span>
              <ButtonDS
                label={translate("welcome.continue.button")}
                rightIcon="ArrowRightIcon"
                onClick={() => continueProcess()}
                size="50"
                className="flex-1"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex bg-[var(--theme-quaternary)] w-full px-[24px] py-[50px]">
        <div className="max-w-[740px] mx-auto flex flex-col items-center gap-[20px] text-center">
          <span className="H2 font-bold text-purple">
            {translate("welcome.sql.contact.title")}
          </span>
          <p className="BodyL text-[#424242] w-fit">
            {translate("welcome.call.question")}{" "}
            <a className="text-purple" href={`tel:${phoneNumber}`}>
              {phoneNumber}
            </a>{" "}
            <ButtonDS
              label={translate("welcome.call.checkWithBroker")}
              leftIcon="PhoneCallIcon"
              buttonType="secondary"
              className="w-full mt-[20px]"
              style={{ textDecoration: "unset" }}
              href={`tel:${phoneNumber}`}
            />
          </p>
        </div>
      </div>
    </>
  );
};

export default DecisionPageSQLLayout;
